import { useState, useRef, Fragment } from 'react'
import {
  Box,
  Input,
  List,
  ListItem,
  InputGroup,
  InputRightElement,
  useOutsideClick,
  InputProps,
  Text,
} from '@chakra-ui/react'

import { Close } from 'components/icons'

type Props = {
  defaultValue?: string
  inputProps?: InputProps
  options: string[]
  onSelect: (value: string) => void
}

export default function CustomFormAutoComplete({ defaultValue = '', options, onSelect, ...inputProps }: Props) {
  const [query, setQuery] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const boxRef = useRef<HTMLDivElement | null>(null)

  useOutsideClick({
    ref: boxRef,
    handler: () => setIsOpen(false),
  })

  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setQuery(value)
    setIsOpen(true)
  }

  const handleFilteredOptions = () => {
    if (query.trim().length > 0) {
      const filteredOptions = options.filter((item) => item.toLowerCase().includes(query.toLowerCase()))
      return filteredOptions
    }
    return options
  }

  const handleFocusInput = () => {
    setIsOpen(true)
  }

  const handleResetValue = () => {
    onSelect('')
    setQuery('')
  }

  const handleResetQueryByValue = () => {
    if (defaultValue) setQuery(defaultValue)
  }

  const handleSelect = (value: string) => {
    onSelect(value)
    setQuery('')
    setIsOpen(false)
  }

  return (
    <Box ref={boxRef} minWidth="100%" maxW="400px" position="relative">
      <InputGroup>
        <Input
          value={query}
          onChange={handleChangeInput}
          onBlur={handleResetQueryByValue}
          onFocus={handleFocusInput}
          {...inputProps}
        />
        <InputRightElement width="max-content" pe={2}>
          {defaultValue && (
            <Close className="accessible" _hover={{ scale: '1.3', color: 'danger' }} onClick={handleResetValue} />
          )}
        </InputRightElement>
      </InputGroup>

      {isOpen && (
        <List
          position="absolute"
          overflowY="auto"
          width="100%"
          maxHeight="300px"
          bg="bgContent"
          borderWidth="1px"
          borderColor="color"
          rounded="md"
          mt={2}
          p={1}
          zIndex={1}
        >
          <Fragment>
            {options.length > 0 ? (
              <Fragment>
                {handleFilteredOptions().map((item) => (
                  <ListItem
                    key={item}
                    px={4}
                    py={2}
                    className="accessible"
                    _hover={{ bg: 'primary' }}
                    onClick={() => handleSelect(item)}
                  >
                    {item}
                  </ListItem>
                ))}
              </Fragment>
            ) : (
              <Box p={2}>
                <Text>Nenhum item para selecionar</Text>
              </Box>
            )}
          </Fragment>
        </List>
      )}
    </Box>
  )
}
